import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';

/**
 * 旧「Schema 管理」聚合页 (/admin/schema) 的兼容重定向 (2026-09-12 拆分):
 *   ?tab=field            → /admin/schema-fields   (基础数据 · 字段字典)
 *   ?tpl=material         → /materials/templates   (材料主数据 · 材料模板)
 *   ?tpl=device           → /devices/templates     (设备工况 · 设备模板)
 *   其余 (tpl=param/默认)  → /param-sets/templates  (官方参数中心 · 参数模板)
 * focus / arch / family / group / processType 等定位参数原样带过去.
 */
function SchemaAdminRedirect() {
    const location = useLocation();
    const q = new URLSearchParams(location.search);
    const tab = q.get('tab');
    const tpl = q.get('tpl');
    q.delete('tab');
    q.delete('tpl');
    let to = '/param-sets/templates';
    if (tab === 'field') to = '/admin/schema-fields';
    else if (tpl === 'material') to = '/materials/templates';
    else if (tpl === 'device') to = '/devices/templates';
    const search = q.toString();
    return <Redirect to={search ? `${to}?${search}` : to} />;
}

export default SchemaAdminRedirect;
